import { render, staticRenderFns } from "./footer-resolution.vue?vue&type=template&id=74722b3d&scoped=true"
import script from "./footer-resolution.vue?vue&type=script&lang=js"
export * from "./footer-resolution.vue?vue&type=script&lang=js"
import style0 from "./footer-resolution.vue?vue&type=style&index=0&id=74722b3d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74722b3d",
  null
  
)

export default component.exports